import { Role } from '../../api';

/**
 * What the two credential screens agree on.
 *
 * The list and the issue form are two screens now
 * ([`StaffCredentialsPage`](./StaffCredentialsPage.tsx) and
 * [`NewCredentialPage`](./NewCredentialPage.tsx)), and both of them show a
 * secret exactly once -- the list after a rotation, the form after an issue.
 * The panel that does it is here so that the sentence explaining why it cannot
 * be shown again is written once.
 */

export const ROLE_LABELS: Record<string, string> = {
  [Role.MACHINE_READ]: 'Somente leitura',
  [Role.MACHINE_WRITE]: 'Leitura e escrita',
};

export interface RevealedSecret {
  readonly clientId: string;
  readonly clientSecret: string;
}

export const CREDENTIALS_COPY = {
  title: 'Credenciais de integração',
  description:
    'Cada credencial pertence a uma única empresa cliente e é usada por um sistema parceiro ' +
    'para chamar a API sem que ninguém faça login.',
  issueTitle: 'Emitir credencial',
  issueDescription:
    'A empresa é escolhida aqui e não pode ser alterada depois: uma credencial alcança uma ' +
    'única empresa por toda a sua vida.',
  issue: 'Emitir credencial',
  issuing: 'Emitindo…',
  issued: 'Credencial emitida.',
  issueFormLabel: 'Emitir credencial de integração',
  back: 'Voltar para a lista de credenciais',
  cancel: 'Cancelar',
  listTitle: 'Credenciais emitidas',
  listDescription:
    'Inclusive as revogadas: quem pôde chamar a API de uma empresa, e até quando, é uma ' +
    'pergunta que precisa de resposta depois do fato.',
  listCaption: 'Credenciais de integração emitidas',
  empty: 'Nenhuma credencial emitida',
  emptyDescription: 'Nenhum sistema parceiro chama a API em nome de uma empresa cliente ainda.',
  loading: 'Carregando credenciais…',
  loadError: 'Não foi possível carregar as credenciais',
  rotatedTitle: 'Segredo substituído',
  secretDescription:
    'Guarde o segredo agora. Ele não é exibido de novo e não pode ser recuperado — uma ' +
    'credencial cujo segredo se perdeu é trocada, não recuperada.',
  secretKept: 'Já guardei o segredo',
} as const;
